import { Component, Input, input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'cmg-validator-messages',
  templateUrl: './cmg-validator-messages.component.html',
  styleUrls: ['./cmg-validator-messages.component.scss'],
  imports: [NgClass],
})
export class CmgValidatorMessagesComponent {
  @Input() control: any;
  readonly customStyle = input<string>(undefined);
  readonly requiredMessage = input('Required');
  @Input() icon?: string;

  /** Indicates if this validation message is for an error, instead of a warning. */
  readonly isError = input<boolean>(undefined);
}
